import styled from 'styled-components';
import posed from 'react-pose';

export const PosedOverlay = posed.div({
  enter: {
    backgroundColor: 'rgba(178, 178, 178, 0.7)',
    transition: {
      backgroundColor: { duration: 300 },
    },
  },
  exit: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    transition: {
      backgroundColor: { duration: 300 },
    },
  },
});

export const Overlay = styled(PosedOverlay)`
  width: 100%;
  height: 100%;
  top: 0;
  overflow: hidden;
  position: fixed;
  z-index: 100;
`;
